import './filter.scss';

export default () => {
	$( '.filter__tab-title a' ).click( function () {
		history.pushState( null, null, $( this ).data( 'url' ) );

		if ( this.id === 'listed-label' ) {
			$( '.filter__right' ).hide();
		} else {
			$( '.filter__right' ).show();
		}
	} );

	$( '.tabs-title.is-active' ).click();
};
